import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { BillLineItem } from "@common/types/bill";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useIdCopy } from "@hooks/useIdCopy";

export const BillNumberCell = memo(
    ({ row }: CellContext<ViewTableFeatures, BillLineItem, string | null>) => {
        const { getCopyProps } = useIdCopy({ label: "Bill" });
        const bill = row.original.bill;

        return (
            <ViewTableCell>
                <span {...getCopyProps(bill?.id)}>{bill?.invoiceNumber}</span>
            </ViewTableCell>
        );
    },
);
